import { render, staticRenderFns } from "./gardenCompositionDetail.vue?vue&type=template&id=681d0f86&"
import script from "./gardenCompositionDetail.vue?vue&type=script&lang=js&"
export * from "./gardenCompositionDetail.vue?vue&type=script&lang=js&"
import style0 from "./gardenCompositionDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports